import { useScreenSize } from '@hooks';
import { Button, Flex, theme, Typography } from '@styles';
import { bool, func, number, object } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const FinishedCard = ({
  correctAnswersCount,
  onFinishButtonPress,
  onTryAgainButtonPress,
  questionsCount,
  titleStyleProps,
  withBorder,
}) => {
  const { i18n } = useTranslation();
  const { isTabletSM } = useScreenSize();

  const percentageCorrect = (correctAnswersCount / questionsCount) * 100;

  return (
    <Flex flexDirection="column" mb={75} mt={3}>
      <Flex
        backgroundColor={theme.colors.hunterGreen[90]}
        flex={1}
        flexDirection="column"
        mb={24}
        py={117}
        {...(withBorder && {
          borderColor: theme.colors.whiteLine[100],
          borderStyle: 'solid',
          borderWidth: 1,
        })}
      >
        <Typography
          color={theme.colors.white[100]}
          mb={3}
          textAlign="center"
          variant={isTabletSM ? 'BN-bold-s56-lh67' : 'BN-bold-s123-lh104'}
          {...titleStyleProps}
        >
          {percentageCorrect >= 50
            ? i18n.t('TestPage.Pass').toUpperCase()
            : i18n.t('ScenarioPage.Failed').toUpperCase()}
        </Typography>
        <Typography
          color={theme.colors.white[60]}
          textAlign="center"
          variant={isTabletSM ? 'MS-regular-s18-lh28' : 'MS-regular-s24-lh37'}
        >
          {`${i18n.t('TestPage.CorrectAnswers')}: ${correctAnswersCount}/${questionsCount}`}
        </Typography>
      </Flex>
      {percentageCorrect < 50 && (
        <Flex
          backgroundColor={theme.colors.white[10]}
          justifyContent="center"
          mb={24}
          py={12}
          width="100%"
        >
          <Typography
            color={theme.colors.white[60]}
            variant="MS-regular-s24-lh28"
          >
            {i18n.t('TestPage.SpendTime')}
          </Typography>
        </Flex>
      )}
      <Flex gap={16} justifyContent="space-between" width="100%">
        <Button
          maxWidth={395}
          onClick={onTryAgainButtonPress}
          variant="secondary"
          whiteSpace="nowrap"
          width="100%"
        >
          <Typography variant="MS-semibold-s16-lh25">
            {i18n.t('ScenarioPage.TryAgain').toUpperCase()}
          </Typography>
        </Button>
        <Button
          maxWidth={395}
          onClick={onFinishButtonPress}
          variant="primary"
          whiteSpace="nowrap"
          width="100%"
        >
          <Typography
            color={theme.colors.black[100]}
            variant="MS-semibold-s16-lh25"
          >
            {i18n.t('ScenarioPage.Finish').toUpperCase()}
          </Typography>
        </Button>
      </Flex>
    </Flex>
  );
};

FinishedCard.propTypes = {
  correctAnswersCount: number.isRequired,
  onFinishButtonPress: func.isRequired,
  onTryAgainButtonPress: func.isRequired,
  questionsCount: number.isRequired,
  titleStyleProps: object,
  withBorder: bool,
};

FinishedCard.defaultProps = {
  titleStyleProps: {},
  withBorder: false,
};

export default FinishedCard;
